/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import {
  TYPE_CAMPAIGN,
  TYPE_BROADCAST,
  TYPE_NEWSLETTER,
  TYPE_DASHBOARD,
  TYPE_SQL_IMPORT,
} from 'cio/utils/segment-usage';
import SegmentModel from 'cio/models/segment';

interface CioSegmentUsageArgs {
  segment: SegmentModel;
}

export default class CioSegmentUsage extends Component<CioSegmentUsageArgs> {
  TYPE_CAMPAIGN = TYPE_CAMPAIGN;
  TYPE_BROADCAST = TYPE_BROADCAST;
  TYPE_NEWSLETTER = TYPE_NEWSLETTER;
  TYPE_DASHBOARD = TYPE_DASHBOARD;
  TYPE_SQL_IMPORT = TYPE_SQL_IMPORT;
}
